"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sanitizeHtml_1 = __importStar(require("@/utils/sanitizeHtml"));
const jquery_1 = __importDefault(require("jquery"));
class MultiCheckboxSelect {
    select;
    props;
    SELECTED_ITEMS = 0;
    LAST_ITEM_INDEX = 0;
    MAPS = {
        option_to_dropdown: new Map(),
        optgroups_to_dropdown_groups: new Map(),
    };
    TOGGLE_ELEMENTS = {
        dropdown_selected: this.toggle_dropdown_selected.bind(this),
        clear_button: this.toggle_clear_button.bind(this),
        select_all_button: this.update_select_all_button.bind(this),
        placeholder: this.update_placeholder.bind(this),
    };
    parent_wrapper = document.createElement("div");
    dropdown;
    dropdown_selected;
    dropdown_wrapper;
    input_wrapper;
    input;
    no_items_in_list_block = document.createElement("p");
    select_all_block;
    select_all_button;
    no_results = document.createElement("p");
    add_item_block = document.createElement("p");
    autocomplete_span = document.createElement("span");
    icon_templates = {
        checkboxIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="14.071" height="11.062"
                                viewBox="0 0 14.071 11.062"><path id="Path_469" data-name="Path 469" d="M13.5,12.054l2.594,2.594L24.742,6"
                                transform="translate(-12.086 -4.586)" fill="none" stroke="#46d2c4"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>`,
        dropdownIcon: `<svg viewBox="0 0 7.029 3.515" class="dropdown-icon">
                            <path id="chevron-down"
                                d="M6.3.105a.439.439,0,1,1,.571.668L3.8,3.409a.439.439,0,0,1-.571,0L.154.773A.439.439,0,1,1,.725.105L3.515,2.5,6.3.106Z"
                                transform="translate(0 0)" fill="inherit" />
                        </svg>`,
        clearIcon: `<svg viewBox="0 0 26.6 26.6" width="26.6" height="26.6" class="clear hidden" xml:space="preserve">
                                <circle cx="13.3" cy="13.3" r="12.3" fill="none" stroke="inherit" stroke-width="2"/>
                                <line x1="7.4" y1="7.4" x2="19.2" y2="19.2" fill="none" stroke="inherit" stroke-width="2" stroke-linecap="round"/>
                                <line x1="19.2" y1="7.4" x2="7.4" y2="19.2" fill="none" stroke="inherit" stroke-width="2" stroke-linecap="round"/>
                            </svg>`,
        searchIcon: `<svg fill="inherit" viewBox="0 0 48 48" width="48px" height="48px" class="search hidden">
                                <path d="M 20.5 6 C 12.509634 6 6 12.50964 6 20.5 C 6 28.49036 12.509634 35 20.5 35 C 23.956359 35 27.133709 33.779044 29.628906 31.75 L 39.439453 41.560547 A 1.50015 1.50015 0 1 0 41.560547 39.439453 L 31.75 29.628906 C 33.779044 27.133709 35 23.956357 35 20.5 C 35 12.50964 28.490366 6 20.5 6 z M 20.5 9 C 26.869047 9 32 14.130957 32 20.5 C 32 23.602612 30.776198 26.405717 28.791016 28.470703 A 1.50015 1.50015 0 0 0 28.470703 28.791016 C 26.405717 30.776199 23.602614 32 20.5 32 C 14.130953 32 9 26.869043 9 20.5 C 9 14.130957 14.130953 9 20.5 9 z"/>
                            </svg>`,
    };
    OBSERVER;
    initializeData(data) {
        this.remove_data_and_reset();
        setTimeout(() => {
            this._initialize_data(data);
        }, 300);
    }
    appendData(data) {
        data.forEach(data => this._append_single_datapoint(data));
    }
    _append_single_datapoint(data) {
        this._format_single_datapoint(data);
        this._add_to_select([data]);
    }
    _create_HTMLOption(data) {
        const option = document.createElement("option");
        if (!data['value']) {
            data['value'] = data['text'];
        }
        Object.entries(data).forEach(([key, value]) => {
            value = value.toString();
            if (key !== "text")
                option.setAttribute(key, value);
            else
                option.textContent = value;
        });
        return option;
    }
    addChildren(children) {
        children.forEach((e) => {
            this.addChild(e);
        });
    }
    addChild(child) {
        if (!(child instanceof Object)) {
            child = document.querySelector(child);
        }
        if (child instanceof jquery_1.default) {
            child = child[0];
        }
        if (child?.hasOwnProperty("__multi_checkbox_select")) {
            this.select.__multi_checkbox_select.children.push(child);
        }
        else {
            throw new Error("Child must be a multi checkbox select instance");
        }
    }
    clear(clearChildren = true) {
        this.clear_selection(clearChildren);
    }
    setPlaceholder(placeholder) {
        this.props.placeholder = placeholder;
        if (!this._is_items_selected()) {
            this.input.placeholder = this.props.placeholder;
        }
    }
    destroy() {
        this.close_dropdown();
        delete this.select.__multi_checkbox_select;
        this.parent_wrapper.parentElement?.insertBefore(this.select, this.parent_wrapper);
        this.parent_wrapper.remove();
    }
    constructor(select, props) {
        if (select === null)
            throw "Select cannot be null";
        if (!(select instanceof HTMLSelectElement))
            throw "Please pass a HTMLSelectElement";
        this.select = select;
        if (this.select.__multi_checkbox_select !== undefined)
            throw "MultiCheckboxSelect is already initialized";
        this.props = this.init_props(props);
        this.select.__multi_checkbox_select = {
            isMouseInsideInput: false,
            isMouseInsideDropdown: false,
            isOpen: false,
            children: [],
            dropdownHeight: 0,
            dropdownWrapper: null,
            dropdown: null,
            dropdownSelected: null,
            inputWrapper: null,
            input: null,
            prevOptions: [],
            _funcs: {
                initializeData: this.initializeData.bind(this),
                appendData: this.appendData.bind(this),
                addChild: this.addChild.bind(this),
                addChildren: this.addChildren.bind(this),
                clear: this.clear.bind(this),
                setPlaceholder: this.setPlaceholder.bind(this),
                destroy: this.destroy.bind(this),
            },
        };
        this.init(this.select, this.props);
        this.global_functions();
        this._initialize_data(this.props.data);
    }
    static positionStyleSheet = null;
    applyDropdownPositionStyles(top, left, width) {
        if (!this.dropdown_wrapper.id) {
            this.dropdown_wrapper.id = `mcs-pos-${Math.random().toString(36).slice(2, 11)}`;
        }
        if (!MultiCheckboxSelect.positionStyleSheet) {
            const sheet = document.createElement('style');
            sheet.id = 'multi-checkbox-select-positions';
            sheet.nonce = window.__CSP_NONCE__ ?? '';
            document.head.appendChild(sheet);
            MultiCheckboxSelect.positionStyleSheet = sheet;
        }
        const selector = `#${this.dropdown_wrapper.id}`;
        const rule = `${selector}{top:${top}px;left:${left}px;width:${width}px}`;
        const sheet = MultiCheckboxSelect.positionStyleSheet;
        const rules = (sheet.textContent || '').split('\n').filter(Boolean);
        const nextRules = rules.filter((line) => !line.startsWith(`${selector}{`));
        nextRules.push(rule);
        sheet.textContent = nextRules.join('\n');
    }
    toggle_dropdown_selected(show) {
        if (show) {
            this.dropdown_selected.classList.remove("hidden");
            this.dropdown_wrapper
                .querySelector(".dropdown-selected-hr")
                ?.classList.remove("hidden");
            this.dropdown_selected.classList.add("dropdown-selected--expanded");
        }
        else {
            this.dropdown_selected.classList.remove("dropdown-selected--expanded");
            this.dropdown_selected.classList.add("hidden");
            this.dropdown_wrapper
                .querySelector("hr.dropdown-selected-hr")
                .classList.add("hidden");
        }
    }
    toggle_clear_button(show) {
        const clear_button = this.input_wrapper.querySelector("svg.clear");
        if (!clear_button)
            return;
        if (show) {
            clear_button.classList.remove("hidden");
            clear_button.classList.remove("clear--visible");
            void clear_button.offsetWidth;
            clear_button.classList.add("clear--visible");
        }
        else {
            clear_button.classList.remove("clear--visible");
            clear_button.classList.add("hidden");
        }
    }
    update_select_all_button() {
        this.SELECTED_ITEMS === this.MAPS.option_to_dropdown.size ? this.select_all_button?.setAttribute("checked", "true") : this.select_all_button?.setAttribute("checked", "false");
    }
    update_placeholder() {
        this.SELECTED_ITEMS === 0 ? this.input.placeholder = this.props.placeholder : this.input.placeholder = `Selected ${this.SELECTED_ITEMS} ${this.props.entryName}(s)`;
    }
    _add_to_select(data, container = this.select) {
        data?.forEach((data_point) => {
            if (data_point["group_name"] !== undefined) {
                const optGroup = this._create_HTMLOptGroup(data_point.group_name);
                container.appendChild(optGroup);
                this._add_to_select(data_point.data, optGroup);
            }
            else {
                const option = this._create_HTMLOption(data_point);
                container.appendChild(option);
            }
        });
    }
    _create_HTMLOptGroup(group_label) {
        const optgroup = document.createElement("optgroup");
        optgroup.setAttribute("label", group_label);
        return optgroup;
    }
    remove_data_and_reset() {
        this.clear_selection(true, false);
        this.close_dropdown();
        this.select.innerHTML = (0, sanitizeHtml_1.default)("");
    }
    _is_items_selected() {
        return this.SELECTED_ITEMS > 0;
    }
    _initialize_data(data = []) {
        if (data === undefined)
            return;
        if (!(data instanceof Array)) {
            throw new Error("Data must be an array");
        }
        const select_clone = document.createElement("select");
        select_clone.innerHTML = (0, sanitizeHtml_1.default)(this.select.innerHTML);
        this.select.innerHTML = (0, sanitizeHtml_1.default)("");
        if (!this.props.multiple) {
            this.OBSERVER.disconnect();
            this.select.innerHTML = (0, sanitizeHtml_1.default)(`<option value="" selected disabled hidden></option>`);
        }
        this.OBSERVER.connect();
        for (let i = 0; i < select_clone.children.length; i++) {
            const child = select_clone.children[i].cloneNode(true);
            if (child instanceof HTMLOptionElement) {
                this.select.appendChild(child);
            }
            else if (child instanceof HTMLOptGroupElement) {
                this.select.appendChild(child);
            }
        }
        data = this._format_external_data(data);
        this._add_to_select(data);
    }
    _format_external_data(data) {
        return data.map(data_point => {
            if (data_point.data !== undefined) {
                data_point.data = this._format_external_data(data_point.data);
                return data_point;
            }
            else {
                return this._format_single_datapoint(data_point);
            }
        });
    }
    _format_single_datapoint(data_point) {
        if (typeof data_point === "string") {
            return { value: data_point, text: data_point };
        }
        else if (data_point["group_name"] !== undefined) {
            return { ...data_point, group_name: data_point["group_name"], data: [] };
        }
        else if (data_point["value"] === undefined) {
            return { ...data_point, value: data_point["text"], text: data_point["text"] };
        }
        else {
            return data_point;
        }
    }
    init(select, props) {
        this.parent_wrapper.classList.add("multi-checkbox-select-wrapper");
        select.parentNode?.insertBefore(this.parent_wrapper, select);
        this.parent_wrapper.appendChild(select);
        const input_wrapper = document.createElement("div");
        input_wrapper.classList.add("input-wrapper");
        input_wrapper.addEventListener("click", () => {
            this.open_dropdown();
        });
        input_wrapper.addEventListener("mouseover", () => {
            select.__multi_checkbox_select.isMouseInsideInput = true;
        });
        input_wrapper.addEventListener("mouseout", () => {
            select.__multi_checkbox_select.isMouseInsideInput = false;
        });
        const input = document.createElement("input");
        input.setAttribute("type", "");
        input.setAttribute("placeholder", props.placeholder);
        if (!props.is_searchable)
            input.setAttribute("readonly", "");
        input_wrapper.innerHTML += (0, sanitizeHtml_1.default)(this.icon_templates.searchIcon);
        input_wrapper.innerHTML += (0, sanitizeHtml_1.default)(this.icon_templates.clearIcon);
        if (props.show_chevron) {
            input_wrapper.innerHTML += (0, sanitizeHtml_1.default)(this.icon_templates.dropdownIcon);
            input_wrapper.querySelector("svg.dropdown-icon").addEventListener("click", (e) => {
                this.close_dropdown() ? e.stopPropagation() : null;
            });
        }
        input_wrapper.insertBefore(input, input_wrapper.childNodes[1]);
        const searchIcon = input_wrapper.querySelector("svg.search");
        searchIcon.classList.add("search--collapsed");
        input_wrapper.querySelector("svg.clear").addEventListener("click", (e) => {
            this.clear_selection();
            e.stopPropagation();
        });
        this.parent_wrapper.prepend(input_wrapper);
        const dropdown_wrapper = document.createElement("div");
        dropdown_wrapper.classList.add("multiselect-dropdown-wrapper", "hidden");
        dropdown_wrapper.addEventListener("mouseover", () => {
            select.__multi_checkbox_select.isMouseInsideDropdown = true;
        });
        dropdown_wrapper.addEventListener("mouseout", () => {
            select.__multi_checkbox_select.isMouseInsideDropdown = false;
        });
        const { dropdown, dropdown_selected } = this.make_dropdowns();
        const hr = document.createElement("hr");
        hr.classList.add("dropdown-selected-hr", "hidden");
        this.no_results.classList.add("no-result");
        this.no_results.classList.add("hidden");
        this.no_results.textContent = "No Results Found";
        this.add_item_block.classList.add("add-item-block");
        this.add_item_block.classList.add("hidden");
        this.add_item_block.addEventListener('click', () => {
            const value = this.add_item_block.querySelector("b")?.innerHTML.replace(/"/g, "");
            this._append_single_datapoint({ text: value, selected: true });
            if (this.props.multiple) {
                this.open_dropdown();
            }
        });
        this.no_items_in_list_block.innerText = "There are no items in this list";
        this.no_items_in_list_block.classList.add("hidden");
        (select.__multi_checkbox_select.input = input), (this.input = input);
        (select.__multi_checkbox_select.inputWrapper = input_wrapper),
            (this.input_wrapper = input_wrapper);
        (select.__multi_checkbox_select.dropdown = dropdown),
            (this.dropdown = dropdown);
        (select.__multi_checkbox_select.dropdownSelected = dropdown_selected),
            (this.dropdown_selected = dropdown_selected);
        (select.__multi_checkbox_select.dropdownWrapper = dropdown_wrapper),
            (this.dropdown_wrapper = dropdown_wrapper);
        dropdown_wrapper.appendChild(dropdown_selected);
        dropdown_wrapper.appendChild(hr);
        dropdown_wrapper.appendChild(dropdown);
        dropdown_wrapper.appendChild(this.no_results);
        dropdown_wrapper.appendChild(this.add_item_block);
        dropdown_wrapper.append(this.no_items_in_list_block);
        if (props.multiple) {
            select.setAttribute("multiple", "");
            dropdown.setAttribute("data-multiple", "true");
            dropdown_selected.setAttribute("data-multiple", "true");
            const select_all_block = document.createElement("div");
            select_all_block.classList.add("select-all");
            const p = document.createElement("p");
            p.textContent = "Select All";
            const select_all_button = document.createElement("button");
            select_all_button.setAttribute("checked", "false");
            select_all_button.setAttribute("type", "button");
            select_all_button.addEventListener("click", () => {
                this.toggle_select_all(select_all_button);
            });
            select_all_block.appendChild(p);
            select_all_block.appendChild(select_all_button);
            select_all_button.innerHTML = (0, sanitizeHtml_1.default)(this.icon_templates.checkboxIcon);
            this.select_all_button = select_all_button;
            this.select_all_block = select_all_block;
            dropdown_wrapper.prepend(document.createElement("hr"));
            dropdown_wrapper.prepend(select_all_block);
            dropdown_wrapper.append(this.no_items_in_list_block);
        }
        this.OBSERVER = new MutationObserver((e) => {
            e.forEach(mutation => {
                if (mutation.type === "attributes") {
                    const option = mutation.target;
                    const option_in_dropdown = this.MAPS.option_to_dropdown.get(option);
                    this._update_dropdown_data(option, option_in_dropdown);
                }
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach(node => {
                        const option = node;
                        if (!this.MAPS.option_to_dropdown.has(option)) {
                            this._add_dropdown_data(node);
                        }
                        if (this.MAPS.option_to_dropdown.size > 0) {
                            this.select_all_block?.classList.remove("hidden");
                            this.no_items_in_list_block.classList.add("hidden");
                        }
                    });
                    mutation.removedNodes.forEach(node => {
                        this._delete_dropdown_data(node);
                        if (this.MAPS.option_to_dropdown.size === 0) {
                            this.select_all_block?.classList.add("hidden");
                            this.no_items_in_list_block.classList.remove("hidden");
                        }
                    });
                }
            });
        });
        this.OBSERVER.connect = (e = this.select) => {
            this.OBSERVER.observe(e, { attributes: true, childList: true, subtree: true, attributeFilter: ["selected"], });
        };
        this.select_all_block?.classList.add("hidden");
        this.no_items_in_list_block.classList.remove("hidden");
        if (this.props.is_disabled) {
            this.parent_wrapper.classList.add("disabled");
        }
    }
    make_dropdowns() {
        const default_group = document.createElement("div");
        default_group.classList.add("default-group");
        const dropdown = document.createElement("div");
        const dropdown_selected = document.createElement("div");
        dropdown.classList.add("dropdown");
        dropdown_selected.classList.add("dropdown", "dropdown-selected", "hidden");
        dropdown.appendChild(dropdown.DEFAULT_GROUP = default_group);
        dropdown_selected.appendChild(dropdown_selected.DEFAULT_GROUP = default_group.cloneNode(true));
        return { dropdown, dropdown_selected };
    }
    _update_dropdown_data(option_in_select, option_in_dropdown) {
        const groups_in_dropdowns = this.MAPS.optgroups_to_dropdown_groups.get(option_in_select.parentElement);
        if (this.props.multiple) {
            const button = option_in_dropdown.querySelector("button");
            const wrapper = button.parentElement;
            option_in_select.getAttribute('selected') != null ? button.setAttribute("checked", "true") : button.setAttribute("checked", "false");
            if (button.getAttribute('checked') === 'true') {
                if (groups_in_dropdowns) {
                    this.insertion_sort(wrapper, groups_in_dropdowns.dropdown_selected_group);
                }
                else {
                    this.insertion_sort(wrapper, this.dropdown_selected.DEFAULT_GROUP);
                }
                this.set_selected_items(++this.SELECTED_ITEMS);
            }
            else {
                if (groups_in_dropdowns) {
                    this.insertion_sort(wrapper, groups_in_dropdowns.dropdown_group);
                }
                else {
                    this.insertion_sort(wrapper, this.dropdown.DEFAULT_GROUP);
                }
                if (this.SELECTED_ITEMS > 0)
                    this.set_selected_items(--this.SELECTED_ITEMS);
            }
        }
        else {
            this.set_single_selection(option_in_select);
        }
    }
    set_selected_items(selected_items) {
        Object.values(this.TOGGLE_ELEMENTS).forEach(func => func(selected_items > 0));
    }
    _add_dropdown_data(element) {
        if (element.tagName === "OPTION") {
            const option = element;
            const option_in_dropdown = this.make_dropdown_item(option);
            const groups_in_dropdowns = this.MAPS.optgroups_to_dropdown_groups.get(option.parentElement);
            this.MAPS.option_to_dropdown.set(option, option_in_dropdown);
            if (!groups_in_dropdowns) {
                this.dropdown.DEFAULT_GROUP.appendChild(option_in_dropdown);
            }
            else {
                groups_in_dropdowns.dropdown_group.appendChild(option_in_dropdown);
            }
            if (option.getAttribute('selected') != null) {
                this._update_dropdown_data(option, option_in_dropdown);
            }
            if (this.props.data_selected.includes(option.value)) {
                option.setAttribute('selected', '');
            }
        }
        else if (element.tagName === "OPTGROUP") {
            const optgroup = element;
            this.make_dropdown_groups(optgroup);
            optgroup.childNodes.forEach(child => {
                if (child.tagName === "OPTION")
                    this._add_dropdown_data(child);
            });
        }
    }
    _delete_dropdown_data(element) {
        if (element.tagName === "OPTION") {
            const option = element;
            const option_in_dropdown = this.MAPS.option_to_dropdown.get(option);
            if (option.getAttribute('selected') != null) {
                if (this.SELECTED_ITEMS > 0)
                    this.set_selected_items(--this.SELECTED_ITEMS);
            }
            this.MAPS.option_to_dropdown.delete(option);
            option_in_dropdown?.remove();
        }
        else if (element.tagName === "OPTGROUP") {
            const optgroup = element;
            const groups_in_dropdowns = this.MAPS.optgroups_to_dropdown_groups.get(optgroup);
            optgroup.querySelectorAll("option").forEach(option => {
                this._delete_dropdown_data(option);
            });
            groups_in_dropdowns?.dropdown_group.remove();
            groups_in_dropdowns?.dropdown_selected_group.remove();
        }
    }
    make_dropdown_item(option_in_select) {
        const wrapper = document.createElement("div");
        const parent = option_in_select.parentElement;
        wrapper.setAttribute("data-index", this.LAST_ITEM_INDEX.toString());
        wrapper.setAttribute("data-text", option_in_select.text);
        this.LAST_ITEM_INDEX++;
        const p = document.createElement("p");
        p.textContent = option_in_select.text;
        wrapper.appendChild(p);
        if (this.props.multiple) {
            const button = document.createElement("button");
            wrapper.appendChild(button);
            button.setAttribute("checked", "false");
            button.setAttribute("type", "button");
            button.addEventListener("click", () => {
                option_in_select.getAttribute("selected") != null ? option_in_select.removeAttribute("selected") : option_in_select.setAttribute("selected", '');
            });
            wrapper.addEventListener("click", (e) => {
                if (e.currentTarget === e.target || e.target === p) {
                    button.click();
                }
            });
            button.innerHTML = (0, sanitizeHtml_1.default)(this.icon_templates.checkboxIcon);
        }
        else {
            wrapper.addEventListener("click", () => {
                option_in_select.setAttribute("selected", '');
                setTimeout(() => { this.close_dropdown(); }, 10);
            });
        }
        return wrapper;
    }
    set_single_selection(option) {
        this.select.value = option.value;
        this.select.__multi_checkbox_select.input.value = option.text;
        this.TOGGLE_ELEMENTS.clear_button(true);
    }
    insertion_sort(item, container) {
        container.appendChild(item);
        let array = container.childNodes;
        for (let i = array.length - 1; i > -1; i--) {
            if (array[i] instanceof HTMLDivElement && item !== array[i]) {
                if (+array[i].getAttribute("data-index") >
                    +item.getAttribute("data-index")) {
                    container.insertBefore(item, array[i]);
                }
            }
        }
    }
    make_dropdown_groups(optgroup) {
        const groupDivElement = this.make_dropdown_group(optgroup);
        const groupDivElementSelected = groupDivElement.cloneNode(true);
        this.dropdown.appendChild(groupDivElement);
        this.dropdown_selected.appendChild(groupDivElementSelected);
        this.MAPS.optgroups_to_dropdown_groups.set(optgroup, {
            dropdown_group: groupDivElement,
            dropdown_selected_group: groupDivElementSelected,
        });
        return [groupDivElement, groupDivElementSelected];
    }
    make_dropdown_group(optgroup) {
        const group = document.createElement("div");
        group.classList.add("opt-group");
        group.setAttribute("data-label", optgroup.getAttribute("label"));
        const p = document.createElement("p");
        p.textContent = optgroup.getAttribute("label");
        group.appendChild(p);
        return group;
    }
    global_functions() {
        document.addEventListener("click", () => {
            if (this.close_able()) {
                this.close_dropdown();
            }
        });
        window.addEventListener("resize", () => {
            if (this.select.__multi_checkbox_select.isOpen) {
                this.position_dropdown();
            }
        });
        this.select.__multi_checkbox_select.input?.addEventListener("focus", () => {
            if (this.props.is_searchable) {
                this.select.__multi_checkbox_select.inputWrapper
                    ?.querySelector("svg.search")
                    ?.classList.remove("search--collapsed");
            }
        });
        this.select.__multi_checkbox_select.input?.addEventListener("blur", () => {
            this.select.__multi_checkbox_select.inputWrapper
                ?.querySelector("svg.search")
                ?.classList.add("search--collapsed");
        });
        this.select.__multi_checkbox_select.input?.addEventListener("input", (e) => {
            this.search(this.select.__multi_checkbox_select.input?.value);
        });
    }
    search(text) {
        const top_result = this.search_global(text);
        !top_result && !this.props.tags ? this.toggle_no_results(true) : this.toggle_no_results(false);
        this.props.tags ? this.toggle_add_item(text) : null;
    }
    toggle_add_item(text) {
        if (text !== '') {
            this.add_item_block?.classList.remove('hidden');
            this.add_item_block.innerHTML = (0, sanitizeHtml_1.default)(`Add <b>"${(0, sanitizeHtml_1.escapeHtml)(text)}"</b>`);
        }
        else {
            this.add_item_block?.classList.add('hidden');
        }
    }
    toggle_no_results(show_results) {
        if (show_results) {
            this.no_results.classList.remove("hidden");
        }
        else {
            this.no_results.classList.add("hidden");
        }
    }
    search_global(text) {
        this.dropdown.childNodes.forEach((group) => {
            if (group instanceof HTMLDivElement) {
                group.childNodes.forEach((option) => {
                    if (option instanceof HTMLDivElement) {
                        if (option.textContent?.toLowerCase().includes(text.toLowerCase())) {
                            option.classList.remove("hidden");
                        }
                        else {
                            option.classList.add("hidden");
                        }
                    }
                });
            }
        });
        return this.dropdown.querySelector("* > div:not(.hidden)[data-index] > p")?.textContent;
    }
    search_group(text) {
        this.dropdown.childNodes.forEach((group) => {
            if (group instanceof HTMLDivElement) {
                if (group
                    .getAttribute("data-label")
                    .toLowerCase()
                    .includes(text.toLowerCase())) {
                    group.classList.remove("is-filtered-out");
                }
                else {
                    group.classList.add("is-filtered-out");
                }
            }
        });
    }
    close_able() {
        return (!this.select.__multi_checkbox_select.isMouseInsideDropdown &&
            !this.select.__multi_checkbox_select.isMouseInsideInput &&
            this.select.__multi_checkbox_select.isOpen);
    }
    toggle_select_all(button) {
        this.search((this.input.value = ""));
        if (button.getAttribute("checked") === "false") {
            this.select.querySelectorAll("option:not([selected])").forEach((option) => {
                option.setAttribute("selected", "");
            });
        }
        else {
            this.select.querySelectorAll("option[selected]").forEach((option) => {
                option.removeAttribute("selected");
            });
        }
    }
    clear_selection(clearChildren = true, fireChange = true) {
        this.search((this.input.value = ""));
        this.toggle_no_results(false);
        if (this.props.multiple)
            this.select.querySelectorAll("option[selected]").forEach((option) => {
                option.removeAttribute("selected");
            });
        else {
            this.select.value = "";
            this.input.value = "";
            this.set_selected_items(0);
        }
        fireChange ? this.fire_change() : null;
        clearChildren ? this.select.__multi_checkbox_select.children.forEach(e => e.__multi_checkbox_select._funcs.clear()) : null;
    }
    close_dropdown() {
        if (this.select.__multi_checkbox_select.isOpen) {
            this.dropdown_wrapper.classList.remove("is-open");
            let closed = false;
            const finishClose = () => {
                if (closed)
                    return;
                closed = true;
                this.select.__multi_checkbox_select.isOpen = false;
                if (this.props.show_chevron) {
                    this.input_wrapper.querySelector("svg.dropdown-icon")
                        ?.classList.remove("dropdown-icon--open");
                }
                this.dropdown_wrapper.classList.add("hidden");
                if (this.dropdown_wrapper.parentElement === document.body) {
                    document.body.removeChild(this.dropdown_wrapper);
                }
                this.check_for_change() ? this.fire_change() : null;
            };
            this.dropdown_wrapper.addEventListener("transitionend", finishClose, { once: true });
            window.setTimeout(finishClose, 250);
            return true;
        }
        return false;
    }
    check_for_change() {
        if (this.props.multiple) {
            if (this.select.__multi_checkbox_select.prevOptions.length !==
                this.select.selectedOptions.length) {
                return true;
            }
            else {
                this.select.__multi_checkbox_select.prevOptions.forEach((option, index) => {
                    if (option.value !== this.select.selectedOptions[index].value) {
                        return true;
                    }
                });
            }
        }
        else {
            if (this.select.__multi_checkbox_select.prevOptions !== this.select.value) {
                return true;
            }
        }
        return false;
    }
    fire_change() {
        const s = this.select;
        const changeEvent = new CustomEvent("change", {
            bubbles: true,
            detail: { s },
        });
        s.dispatchEvent(changeEvent);
    }
    open_dropdown() {
        if (!this.select.__multi_checkbox_select.isOpen) {
            this.dropdown_wrapper.classList.remove("hidden");
            document.body.appendChild(this.dropdown_wrapper);
            this.position_dropdown();
            requestAnimationFrame(() => {
                this.dropdown_wrapper.classList.add("is-open");
                if (this.select.__multi_checkbox_select.dropdownHeight <
                    this.dropdown.offsetHeight) {
                    this.select.__multi_checkbox_select.dropdownHeight =
                        this.dropdown.offsetHeight;
                }
            });
            if (this.props.show_chevron) {
                this.input_wrapper.querySelector("svg.dropdown-icon")
                    ?.classList.add("dropdown-icon--open");
            }
            this.select.__multi_checkbox_select.isOpen = true;
            this.input.focus();
            this.input.select();
            if (this.props.multiple) {
                this.select.__multi_checkbox_select.prevOptions = Array.from(this.select.selectedOptions).map((e) => e);
            }
            else {
                this.select.__multi_checkbox_select.prevOptions = this.select.value;
            }
        }
    }
    position_dropdown() {
        const rect = this.input_wrapper.getBoundingClientRect();
        this.applyDropdownPositionStyles(rect.top + rect.height + window.scrollY, rect.left + window.scrollX, rect.width);
    }
    init_props(props) {
        return {
            data: props !== undefined && props.data !== undefined ? props.data : [],
            placeholder: this.select.getAttribute("data-placeholder") === null
                ? props !== undefined && props.placeholder !== undefined
                    ? props.placeholder
                    : "Select"
                : this.select.getAttribute("data-placeholder"),
            multiple: props !== undefined && props.multiple !== undefined
                ? props.multiple
                : false || this.select.getAttribute("multiple") !== null,
            entryName: props !== undefined && props.entryName !== undefined
                ? props.entryName
                : "Entrie",
            value: props !== undefined && props.value !== undefined
                ? props.value
                : "",
            tags: props !== undefined && props.tags !== undefined
                ? props.tags
                : false || this.select.getAttribute("tags") !== null,
            show_chevron: props !== undefined && props.show_chevron !== undefined
                ? props.show_chevron
                : this.select.getAttribute("show-chevron") === null ? true : this.select.getAttribute("show-chevron") === 'true',
            is_searchable: props !== undefined && props.is_searchable !== undefined
                ? props.is_searchable
                : this.select.getAttribute("searchable") === null ? true : this.select.getAttribute("searchable") === 'true',
            data_selected: props !== undefined && props.data_selected !== undefined ? props.data_selected.split(',') : this.select.getAttribute("data-selected") !== null ? this.select.getAttribute("data-selected").split(',') : [],
            is_disabled: props !== undefined && props.is_disabled !== undefined ? props.is_disabled : this.select.getAttribute("disabled") !== null ? true : false,
        };
    }
}
exports.default = MultiCheckboxSelect;
try {
    jquery_1.default.fn.extend({
        multiCheckboxSelect: function (properties) {
            let self = this[0];
            return this.each(() => {
                new MultiCheckboxSelect(self, properties);
            });
        },
        initializeData: function (data) {
            let self = this[0];
            let dataCopy = JSON.parse(JSON.stringify(data));
            return this.each(() => {
                self.__multi_checkbox_select._funcs.initializeData(dataCopy);
            });
        },
        appendData: function (data) {
            let self = this[0];
            let dataCopy = JSON.parse(JSON.stringify(data));
            return this.each(() => {
                self.__multi_checkbox_select._funcs.appendData(dataCopy);
            });
        },
        addChild: function (child) {
            let self = this[0];
            return this.each(() => {
                self.__multi_checkbox_select._funcs.addChild(child);
            });
        },
        addChildren: function (children) {
            let self = this[0];
            return this.each(() => {
                self.__multi_checkbox_select._funcs.addChildren(children);
            });
        },
        clear: function () {
            let self = this[0];
            return this.each(() => {
                self.__multi_checkbox_select._funcs.clear();
            });
        },
        setPlaceholder: function (placeholder) {
            let self = this[0];
            return this.each(() => {
                self.__multi_checkbox_select._funcs.setPlaceholder(placeholder);
            });
        },
        destroy: function () {
            let self = this[0];
            return this.each(() => {
                self.__multi_checkbox_select._funcs.destroy();
            });
        },
    });
}
catch (e) { }
function multiCheckboxSelectArr(arr) {
    for (let i = 0; i < arr.length; i++) {
        new MultiCheckboxSelect(arr[i], undefined);
    }
}
multiCheckboxSelectArr(document.querySelectorAll('.multi-checkbox-select'));
